import { EntityWidget } from "./EntityWidget";
import { SunEntityController } from "../SunEntityController";
import { Sun } from "@rhinov/savane-js";

export class SunEntityWidget extends EntityWidget{

    declare entity: Sun;
    declare controller: SunEntityController;

    constructor(entity: Sun, panel: any) {
        super(entity, panel, null);
        this.controller = new SunEntityController(entity, panel);
        this.propertiesTab = ['dropDown', 'range', 'range', 'dropDown', 'dropDown', 'range', 'buttonToggle', 'range', 'range', 'range'];
        this.controller.propertiesTab = this.propertiesTab;
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }

        return html + super.propertyEnd();
    }
}